(function () {
  if (window.BlagowoodSplitEditorialLoaded) return;
  window.BlagowoodSplitEditorialLoaded = true;

  class BlagowoodSplitSlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = Array.from(this.querySelectorAll('[data-split-slider-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-split-slider-dot]'));
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.pointerStartX = null;

      this.querySelector('[data-split-slider-previous]')?.addEventListener('click', () => this.goTo(this.index - 1));
      this.querySelector('[data-split-slider-next]')?.addEventListener('click', () => this.goTo(this.index + 1));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.splitSliderDot))));
      this.addEventListener('keydown', this.onKeydown.bind(this));
      this.addEventListener('pointerdown', this.onPointerDown.bind(this));
      this.addEventListener('pointerup', this.onPointerUp.bind(this));
      this.addEventListener('pointercancel', () => { this.pointerStartX = null; });
      this.goTo(this.index, false);
    }

    onKeydown(event) {
      if (event.key === 'ArrowLeft') this.goTo(this.index - 1);
      if (event.key === 'ArrowRight') this.goTo(this.index + 1);
    }

    onPointerDown(event) {
      if (event.pointerType === 'mouse') return;
      this.pointerStartX = event.clientX;
    }

    onPointerUp(event) {
      if (this.pointerStartX === null) return;
      const distance = event.clientX - this.pointerStartX;
      this.pointerStartX = null;
      if (Math.abs(distance) < 45) return;
      this.goTo(distance > 0 ? this.index - 1 : this.index + 1);
    }

    goTo(requestedIndex, focusDot = false) {
      if (this.slides.length < 1) return;
      this.index = (requestedIndex + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.dots.forEach((dot, index) => {
        const active = index === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
      if (focusDot && this.dots[this.index]) this.dots[this.index].focus();
    }
  }

  if (!customElements.get('blagowood-split-slider')) {
    customElements.define('blagowood-split-slider', BlagowoodSplitSlider);
  }

  document.addEventListener('shopify:block:select', (event) => {
    const selectedSlide = event.target.closest('[data-split-slider-slide]');
    const slider = selectedSlide && selectedSlide.closest('blagowood-split-slider');
    if (!slider || !slider.slides) return;
    const index = slider.slides.indexOf(selectedSlide);
    if (index >= 0) slider.goTo(index);
  });
})();
